import React from 'react';
import {Row, Col, Table, Button } from 'antd';
import moment from 'moment'
import { useTranslation } from 'react-i18next';

const InfoPep = ({infoPep={}, record, actual, forceExpand}) => {
    const { t } = useTranslation();
    
    const publicRecColumns = [
        {
            title: t("messages.aml.publicAgency"),
            dataIndex: 'orgPublic'
        },
        {
            title: t("messages.aml.position"),
            dataIndex: 'cargo'
        },
        {
            title: t("messages.aml.country"),
            dataIndex: 'pais'
        },
        {
            title: t("messages.aml.endDate"),
            dataIndex: 'fecTermino',
            render: (date) => {
            return moment(date).format('DD/MM/YYYY')
            }
        },
    ]
    const familyRecColumns = [
        {
        title: t("messages.aml.publicAgency"),
        dataIndex: 'orgPublic'
        },
        {
        title: t("messages.aml.country"),
        dataIndex: 'pais'
        },
        {
        title: t("messages.aml.relationship"),
        dataIndex: 'parentesco'
        },
        {
        title: t("messages.aml.name"),
        dataIndex: 'nombrePariente'
        },
        {
        title: t("messages.aml.identificationNumber"),
        dataIndex: 'nroIdPariente'
        },
        {
        title: t("messages.aml.position"),
        dataIndex: 'cargo'
        },
        {
        title: t("messages.aml.endDate"),
        dataIndex: 'fecTermino',
        render: (date) => {
            return moment(date).format('DD/MM/YYYY')
        }
        },
    ]

    const relationRecColumns = [
        {
            title: t("messages.aml.company"),
            dataIndex: 'empresa'
        },
        {
            title: t("messages.aml.identificationNumber"),
            dataIndex: 'nroIdentificacion'
        },
        {
            title: t("messages.aml.group"),
            dataIndex: 'grupo'
        },
        {
            title: t("messages.aml.country"),
            dataIndex: 'pais'
        },
        ]
    return (
        <div>
            <Row gutter={[32, 12]}>
                <Col span={22}>
                    {record.type === 'Person' ?
                    t("messages.aml.pepPublicPositionPerson")
                    :
                    t("messages.aml.pepPublicPositionEntity")
                    }
                </Col>
                <Col span={2} >
                    <Button type="primary" className={"no-btn radioDecision " + (actual && infoPep.isPublic !== actual.isPublic ? "difference" : "")}>
                        {infoPep.isPublic ? t("messages.aml.yes") : t("messages.aml.no")}
                    </Button>
                </Col>
            </Row>
            {infoPep.isPublic &&
                <Row gutter={[32, 12]}>
                    <Col span={24}>
                    <Table
                        className={actual && infoPep.publicRecords !== actual.publicRecords && "difference"}
                        columns={publicRecColumns}
                        dataSource={infoPep.publicRecords}
                        pagination={!forceExpand && infoPep.publicRecords?.length > 10 }
                    />
                    </Col>
                </Row>
            }
            <Row gutter={[32, 12]}>
                <Col span={22}>
                    {record.type === 'Person' ?
                    t("messages.aml.pepFamilyRelationshipPerson")
                    :
                    t("messages.aml.pepFamilyRelationshipEntity")
                    }
                </Col>
                <Col span={2}>
                    <Button type="primary" className={"no-btn radioDecision " + (actual && infoPep.hasFamily !== actual.hasFamily ? "difference" : "")}>
                    {infoPep.hasFamily ? t("messages.aml.yes") : t("messages.aml.no")}
                    </Button>
                </Col>
            </Row>
            {infoPep.hasFamily &&
                <Row gutter={[32, 12]}>
                    <Col span={24}>
                    <Table
                        className={actual && infoPep.familyRecords !== actual.familyRecords && "difference"}
                        columns={familyRecColumns}
                        dataSource={infoPep.familyRecords}
                        pagination={!forceExpand && infoPep.familyRecords?.length > 10 }
                    />
                    </Col>
                </Row>
            }
            <Row gutter={[32, 12]}>
                <Col span={22}>
                    {record.type === 'Person' ?
                    t("messages.aml.pepJointActionPactPerson")
                    :
                    t("messages.aml.pepJointActionPactEntity")
                    }
                </Col>
                <Col span={2}>
                    <Button type="primary" className={"no-btn radioDecision " + (actual && infoPep.hasRelation !== actual.hasRelation ? "difference" : "")}>
                    {infoPep.hasRelation ? t("messages.aml.yes") : t("messages.aml.no")}
                    </Button>
                </Col>
            </Row>
            {infoPep.hasRelation &&
                <Row gutter={[32, 12]}>
                    <Col span={24}>
                        <Table
                            className={actual && infoPep.relationRecords !== actual.relationRecords && "difference"}
                            columns={relationRecColumns}
                            dataSource={infoPep.relationRecords}
                            pagination={!forceExpand && infoPep.relationRecords?.length > 10 }
                        />
                    </Col>
                </Row>
            }
        </div>
    );
};

export default InfoPep;